import axios from 'axios'

axios.defaults.baseURL = process.env.VUE_APP_API_URL

export default {
  getHeaders () {
    const user = JSON.parse(sessionStorage.getItem('user'))

    return {
      id: user ? user.login : ''
    }
  },

  async searchLogin (credentials) {
    return axios.post('/oublicodeacces/oubliidentifiant', credentials, { headers: this.getHeaders(), withCredentials: true })
  },

  async searchPassword (credentials) {
    return axios.post('/oublicodeacces/oublipassword', credentials, { headers: this.getHeaders(), withCredentials: true })
  }

}
